import { useFile } from '../../context/AppContext.jsx';

export default function FileInfoSection() {
  const { currentFileData } = useFile();

  if (!currentFileData) return null;

  return (
    <section className="mb-6">
      <h2 className="text-lg font-semibold mb-4">File Information</h2>
      <div className="grid grid-cols-1 gap-3">
        <div className="flex justify-between">
          <span className="text-text-secondary">File Name:</span>
          <span className="text-text-primary">{currentFileData.fileName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-text-secondary">Program Name:</span>
          <span className="text-text-primary">{currentFileData.programName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-text-secondary">Robot Serial:</span>
          <span className="text-text-primary">{currentFileData.robotSerial}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-text-secondary">Waypoints:</span>
          <span className="text-text-primary">{currentFileData.waypointCount}</span>
        </div>
      </div>
    </section>
  );
}


